import * as Yup from 'yup';

// Fonction pour créer un schéma de validation dynamique
export const createAddressValidationSchema = (useSameAddress = false) => {
  const shippingSchema = Yup.object().shape({
    address_1: Yup.string().required('Adresse requise'),
    city: Yup.string().required('Ville requise'),
    postcode: Yup.string().required('Code postal requis'),
    country: Yup.string().required('Pays requis'),
    first_name: Yup.string().required('Prénom requis'),
    last_name: Yup.string().required('Nom requis'),
    state: Yup.string().optional(),
    company: Yup.string().optional(), // Company optionnel dans shipping aussi
  });

  const billingSchema = useSameAddress 
    ? Yup.object().shape({
        // Si même adresse, les champs billing sont optionnels car ils seront copiés depuis shipping
        address_1: Yup.string().optional(),
        city: Yup.string().optional(),
        postcode: Yup.string().optional(),
        country: Yup.string().optional(),
        first_name: Yup.string().optional(),
        last_name: Yup.string().optional(),
        state: Yup.string().optional(),
        company: Yup.string().optional(),
      })
    : Yup.object().shape({
        // Si adresses différentes, les champs billing sont obligatoires
        address_1: Yup.string().required('Adresse requise'),
        city: Yup.string().required('Ville requise'),
        postcode: Yup.string().required('Code postal requis'),
        country: Yup.string().required('Pays requis'),
        first_name: Yup.string().required('Prénom requis'),
        last_name: Yup.string().required('Nom requis'),
        state: Yup.string().optional(),
        company: Yup.string().optional(),
      });

  return Yup.object().shape({
    shipping: shippingSchema,
    billing: billingSchema,
  });
};

// Schéma de validation statique pour compatibilité (utilise useSameAddress = false par défaut)
export const addressValidationSchema = createAddressValidationSchema(false);

// Schéma de validation pour une adresse individuelle (pour les modals d'adresse)
export const singleAddressValidationSchema = Yup.object().shape({
  street: Yup.string().required('Adresse requise'),
  city: Yup.string().required('Ville requise'),
  postcode: Yup.string().required('Code postal requis'),
  isoCountry: Yup.string().required('Pays requis'),
  state: Yup.string().optional(),
  company: Yup.string().optional(),
  legalFirstname: Yup.string().optional(),
  legalLastname: Yup.string().optional(),
  isPrimary: Yup.boolean().optional(),
});